import { supabase } from "@/integrations/supabase/client";

interface ClickEvent {
  button_id: string;
  button_label?: string;
  page_path: string;
}

const BATCH_SIZE = 10;
const FLUSH_INTERVAL_MS = 15_000; // 15 seconds

let queue: ClickEvent[] = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS);
}

function flush() {
  flushTimer = null;
  if (queue.length === 0) return;

  const batch = queue.splice(0);
  try {
    supabase
      .from("click_events" as any)
      .insert(batch as any)
      .then(); // fire and forget
  } catch {
    // Silent - tracking should never break main flow
  }
}

// Flush remaining events when user leaves the page
if (typeof window !== "undefined") {
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
}

/**
 * Batched button click tracker.
 * Queues events and flushes them in bulk every 15s or when 10 events accumulate.
 * Non-blocking - errors are silently caught so it never disrupts UX.
 */
export function trackClick(buttonId: string, buttonLabel?: string) {
  try {
    queue.push({
      button_id: buttonId,
      button_label: buttonLabel,
      page_path: window.location.pathname,
    });

    if (queue.length >= BATCH_SIZE) {
      flush();
    } else {
      scheduleFlush();
    }
  } catch {
    // Silent
  }
}
